import React, { useEffect, useState } from "react";


import CustomButton from "../../Components/CustomButton";
import CustomModal from "../../Components/CustomModal";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import CustomTable from "./../../Components/CustomTable";

import "./style.css";

import { placeholderImage } from "../../Assets/images";
import Header from "../../Components/Header";
import { useGetUsersQuery, useUpdateUserMutation } from "../../Redux/Apis/User";
import { useGetRefundsQuery } from "../../Redux/Apis/Refund";
import ProfileDisplay from "../../Components/ProfileDisplay";
import useSearch from "../../Hooks/useSearch";
import usePagination from "../../Hooks/usePagination";

const sortValues = [
  {
    text: "CreatedAt",
    value: "createdAt",
  }
];

const perPageValues = [
  {
    text: "8",
    value: 8,
  },
  {
    text: "15",
    value: 15,
  },
  {
    text: "30",
    value: 30,
  }
];



const maleHeaders = [
  {
    key: "id",
    title: "Contract No",
  },
  {
    key: "profile_name",
    title: "Profile Name",
  },
  {
    key: "iban",
    title: "IBAN Number",
  },
  {
    key: "bank_name",
    title: "Bank Name",
  },
  {
    key: "name_account",
    title: "Name on Account",
  },
  {
    key: "amount",
    title: "Amount",
  },
  {
    key: "reciept_no",
    title: "Receipt No",
  },
  {
    key: "actions",
    title: "",
  },
];

const RefundRequests = () => {

  const [changeUserStatus, { isLoading: isUpdating }] = useUpdateUserMutation();

  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(perPageValues[0].value);
  const [inputValue, setInputValue] = useState('');
  const [selectedUserId, setSelectedUserId] = useState();
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [sortBy, setSortBy] = useState(sortValues[0].value);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const [search, debouncedSearch, onSearch] = useSearch()
  const { page, perPage, onNext, onPrevious } = usePagination()
  const { data, isLoading, refetch } = useGetRefundsQuery({
    page,
    rowsPerPage: perPage,
    search: debouncedSearch,
    sortBy,
    from,
    to,
  });

  const toggleFilter = () => setIsFilterOpen(!isFilterOpen)

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const inactiveMale = async () => {
    await changeUserStatus({ id: selectedUserId, payload: { active: false } })
    refetch()
    setSelectedUserId()
    setShowModal(false)
    setShowModal2(true)
  }

  const activeMale = async () => {
    await changeUserStatus({ id: selectedUserId, payload: { active: true } })
    refetch()
    setSelectedUserId()
    setShowModal3(false)
    setShowModal4(true)
  }

  const handleChange = (e) => {
    setInputValue(e.target.value);
  }

  useEffect(() => {
    document.title = 'Landing List | Refund Requests';
  }, []);

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <Header
                  title="Refund Requests"
                  search={search}
                  onSearch={onSearch}
                />
                <div className="row mb-3">
                  {
                    isLoading ? <Loader /> :
                      <div className="col-12">
                        <CustomTable
                          headers={maleHeaders}
                          isFilterOpen={isFilterOpen}
                          dateFilter={false}
                          filterSort={false}
                          perPage={true}
                          filterSortValues={sortValues}
                          perPageValues={perPageValues}
                          filterSortValue={sortBy}
                          setFilterSortValue={setSortBy}
                          filterFrom={from}
                          setFilterFrom={setFrom}
                          filterTo={to}
                          setFilterTo={setTo}
                          itemsPerPage={itemsPerPage}
                          setItemsPerPage={setItemsPerPage}
                          length={data?.data?.length}
                          page={page}
                          rowsPerPage={perPage}
                          onNext={onNext}
                          onPrevious={onPrevious}
                          total={data?.total}
                        >
                          <tbody>
                            {data?.data?.map((item, index) => (
                              <tr key={item._id}>
                                {/* <td><input type="checkbox" /></td> */}
                                <td>{(index + 1) + ((currentPage - 1) * itemsPerPage)}</td>
                                <td className="text-capitalize">
                                  <ProfileDisplay
                                    name={`${item?.user?.first_name} ${item?.user?.last_name}`}
                                    image={item?.user?.profile_photo}
                                  />
                                </td>
                                <td>{item?.payout?.iban_number}</td>
                                <td>{item?.payout?.bank_name}</td>
                                <td>{item?.payout?.account_name}</td>
                                <td>{item?.booking?.total_amount} SAR</td>
                                <td>{item.reciept_no}</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <CustomButton variant="primaryButton" text="Mark Completed" className="mx-1" />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </CustomTable>
                      </div>
                  }
                </div>
              </div>
            </div>
          </div>

          <CustomModal loading={isUpdating} show={showModal} close={() => { setShowModal(false) }} action={inactiveMale} heading='Are you sure you want to mark this user as inactive?' />
          <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading='Marked as Inactive' />

          <CustomModal loading={isUpdating} show={showModal3} close={() => { setShowModal3(false) }} action={activeMale} heading='Are you sure you want to mark this user as Active?' />
          <CustomModal show={showModal4} close={() => { setShowModal4(false) }} success heading='Marked as Active' />
        </div>
      </DashboardLayout>
    </>
  );
};

export default RefundRequests
